import React from 'react'
import styles from './DataTable.css'

export const TableServices = ({services, statusAll, totalNeto, iva, total, statusPaymentService, statusPaymentAll, canUpdateServices}) => {
    return (
        <div className="table-responsive">
            <table className={`table table-striped ${styles.DataTable}`}>
                <thead>
                <tr>
                    <th>Fecha Servicio</th>
                    <th>Cliente</th>
                    <th>CECO</th>
                    <th className={styles.DataTable_thNameStore}>Local</th>
                    <th>Región</th>
                    <th>Comuna</th>
                    <th>Und Contadas</th>
                    <th>Valor Unidad</th>
                    <th>Valor Afecto</th>
                    <th>Acta Pdf</th>
                    <th>
                        <input 
                            type="checkbox" 
                            className="form-check-input" 
                            checked={statusAll}
                            onChange={(evt) => statusPaymentAll(evt)}
                            disabled={!canUpdateServices}
                        />
                    </th>
                </tr>
                </thead>
                <tbody>
                  {services.map((service)=>
                    <tr key={service.service_id}>
                        <td>{service.service_date}</td>
                        <td className={styles.DataTable_tdNameClient}>{service.client_name}</td>
                        <td className={styles.DataTable_tdCeco}>{service.store_ceco}</td>
                        <td className={styles.DataTable_tdNameStore}>{service.store_name}</td>
                        <td>{service.store_region}</td>
                        <td>{service.store_comuna}</td>
                        <td className={styles.DataTable_tdTotalService}>{service.units_counted.toLocaleString("es-CL")}</td>
                        <td className={styles.DataTable_tdTotalService}>{"$"+service.unit_value}</td>
                        <td className={styles.DataTable_tdTotalService}>{service.total_billing.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                        <td>
                            <a className="btn btn-success btn-xs"
                               href={`/inventario/archivo-final/${service.final_file_id}/descargar-acta`}>
                                <span className="glyphicon glyphicon-download"/>
                            </a>
                        </td>
                        <td>
                            <input type="checkbox" className="form-check-input" checked={service.approve_client} onChange={(evt) => statusPaymentService(service.service_id, evt)} disabled={!canUpdateServices}/>
                        </td>
                    </tr>
                  )}
                  <tr className="success">
                      <td colSpan="7"></td>
                      <td className={styles.DataTable_tdFinalTotalsText}>Valor Neto</td>
                      <td className={styles.DataTable_tdFinalTotals}>{totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                      <td colSpan="2"></td>
                  </tr>
                  <tr className="success">
                      <td colSpan="7"></td>
                      <td className={styles.DataTable_tdFinalTotalsText}>IVA</td>
                      <td className={styles.DataTable_tdFinalTotals}>{iva.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                      <td colSpan="2"></td>
                  </tr>
                  <tr className="success">
                      <td colSpan="7"></td>
                      <td className={styles.DataTable_tdFinalTotalsText}>Total</td>
                      <td className={styles.DataTable_tdFinalTotals}>{total.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</td>
                      <td colSpan="2"></td>
                  </tr>
                </tbody>
            </table>
        </div>    
    )
}


// WEBPACK FOOTER //
// ./frontEnd/billing/management-oc/DataTable.jsx